export default __webpack_public_path__ + "static/media/subtract.c683ed76.svg";